import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/payroll/settings')({
  beforeLoad: () => {
    throw redirect({ to: '/hr/settings' })
  },
})
